import { render, staticRenderFns } from "./UserDropdownSidebar.vue?vue&type=template&id=fde9c43e&"
import script from "./UserDropdownSidebar.vue?vue&type=script&lang=js&"
export * from "./UserDropdownSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports